


import React from "react";
import { Link } from "react-router-dom";
import "../styles/about.css";
import aboutImg from "../images/about-industrial.webp";

function AboutPreview() {
  return (
    <section className="about">
      <div className="container about-flex">

        {/* TEXT */}
        <div className="about-text">
          <span className="about-tag">About Us</span>

          <h2>
            Trusted Industrial Trading <br />
            Partner You Can Rely On
          </h2>

          <p>
            Apex Trade Connect FZ-LLC is a general trading company specializing in
            a diverse range of industrial products. We are committed to quality,
            reliability, and building long-term partnerships across industries.
          </p>

          <ul className="about-points">
            <li>
              <i className="fa fa-industry"></i>
              Wide range of industrial products
            </li>
            <li>
              <i className="fa fa-truck"></i>
              Reliable and efficient supply chain
            </li>
            <li>
              <i className="fa fa-handshake-o"></i>
              Customer-focused trading solutions
            </li>
          </ul>

          <Link to="/about" className="about-btn">
            Read More
            <i className="fa fa-arrow-right"></i>
          </Link>
        </div>

        {/* IMAGE */}
        <div className="about-image">
          <img src={aboutImg} alt="Industrial Trading" />
        </div>

      </div>
    </section>
  );
}

export default AboutPreview;
